// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__33Eet","image":"Header_image__2CWfK","name":"Header_name__f1tXI","info":"Header_info__1Flx-","infoRow":"Header_infoRow__feZT7"};